import { KeyFlowMessageType } from 'commons/constants/type';
import { ReasonPhrases, StatusCodes, getReasonPhrase, getStatusCode } from 'http-status-codes';
import { SERVICE_ERROR } from 'commons/constants/KeyFlowMessage';

class KeyFlowError extends Error {
  code: number;
  name: string;
  korMessage: string;
  engMessage: string;
  httpStatus: StatusCodes;

  constructor(keyflowMessage: KeyFlowMessageType, httpStatus?: StatusCodes) {
    super(keyflowMessage.korMessage);
    this.code = keyflowMessage.code;
    this.httpStatus = httpStatus || StatusCodes.OK;
    this.name = keyflowMessage.name;
    this.korMessage = keyflowMessage.korMessage;
    this.engMessage = keyflowMessage.engMessage;
  }
}

export default KeyFlowError;
